import React, { useState, FormEvent } from 'react';
import axios from 'axios';
import { API_URL, getErrorMessage } from '../types';
import { useTranslation } from '../i18n';
import { Link } from 'react-router-dom';
import { useApiRequest } from '../useApiRequest';
import { FormLabel } from './FormLabel';
import { validateFormSubmit } from '../utils/formValidation';

export const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const { loading, call } = useApiRequest(async () => {
    await axios.post(`${API_URL}/auth/forgot-password`, { email });
    setSubmitted(true);
  });

  const handleSubmit = async (e: FormEvent) => {
    if (!validateFormSubmit(e)) return;
    e.preventDefault();
    setError('');
    try {
      await call();
    } catch (err) {
      setError(getErrorMessage(err, t('forgot.generic_error')));
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>{t('forgot.title')}</h2>
        {submitted ? (
          <>
            <p className="login-subtitle">{t('forgot.check_email')}</p>
            <div className="alert alert-success" style={{ marginBottom: '1rem' }}>
              {t('forgot.success')}
            </div>
            <Link to="/login" className="btn btn-primary" style={{ width: '100%', textAlign: 'center' }}>
              {t('forgot.back_to_login')}
            </Link>
          </>
        ) : (
          <>
            <p className="login-subtitle">{t('forgot.subtitle')}</p>
            {error && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <FormLabel required>{t('forgot.email')}</FormLabel>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder={t('forgot.email_placeholder')}
                  required
                  disabled={loading}
                  aria-required="true"
                />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
                {loading && <span className="btn-spinner" aria-hidden="true" />}
                {loading ? t('forgot.sending') : t('forgot.submit')}
              </button>
              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <Link to="/login" className="forgot-link">{t('forgot.back_to_login')}</Link>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
